<template>
    <div class="wrap clearn" style="background:#000;">
        <!-- 课程视频播放部分 -->
        <div class="videoBox" :style="[{margin:(isOpen == false?'':'0 auto')},{float:(isOpen == false?'left':'')}]">
            
            <!-- 音频播放 -->
            <div 
                class="videoWrap fl" 
                ref="audio_area" 
                v-if="!isVideo" 
                :style="{height:videoHeight}" 
                style="display:table;" 
                @mouseover="mouseOverBack" 
                @mouseleave="mouseLeaveBack" 
            >
                <div class="backTip" v-show="isHaveTip" @mouseover="mouseOverBack" >
                    <img src="../../../assets/images/fanhui.png" alt="" @click="backPage">
                    <span @click="backPage">返回</span>
                </div>
                <span class="ypImg"><img :src="courseImg" alt=""></span>
                
                <audio 
                    controls 
                    class="ypCourse" 
                    ref="audio_wrap" 
                    controlsList="nodownload"
                    autoplay='true'
                    @play="audioPlay()"
                    @ended="audioEnded()"
                    @pause="audioPause()"
                >
                    <!-- <source :src="isAudioUrl" type="audio/mpeg"> -->
                    您的浏览器不支持 audio 元素。
                </audio>
            </div>
            <!-- 视频播放 -->
            <div 
                class="videoWrap fl" 
                ref="video_area" 
                v-else 
                :style="{height:videoHeight}"
                @mouseover="mouseOverBack" 
                @mouseleave="mouseLeaveBack" 
            >
                <div class="backTip" v-show="isHaveTip"  @mouseover="mouseOverBack">
                    <img src="../../../assets/images/fanhui.png" alt="" @click="backPage">
                    <span @click="backPage">返回</span>
                    <!-- <i :class="isOpen == false?'el-icon-arrow-right fr':'el-icon-arrow-left fr'"></i> -->
                </div>
                
                <video-player 
                    class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    name="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions"
                    @play="onPlayerPlay($event)"
                    @pause="onPlayerPause($event)"
                    @ended="onPlayerEnded($event)"
                    @statechanged="playerStateChanged($event)"
                    @timeupdate="onPlayerTimeupdate($event)"
                    style="height:100%"
                >
                </video-player>
                <!-- <img :src="isOpen == false?openImg:closeImg" alt="" @click="openWrap" class="putAway" :style="{top:iconHeight}"> -->
            </div>
        </div>
        
        <!-- 课程章节选择部分 -->
        <div class="commentWrap fr" v-show="!isOpen">
            <div :style="{height:videoHeight}">
                <div class="courseHeader">
                    <div class="flex" style="align-items: flex-start;">
                        <img :src="courseImg" alt="" class="yuyinIcon" style="border-radius:8px;">
                        <div class="courseTitle" :title="courseTitle">{{courseTitle}}</div>
                    </div>
                    <div class="courseTeacher">
                        <span>主讲老师：{{courseTeacher}}</span>
                        <em class="courseDetail fr" @click="toDetail">课程详情>></em>
                    </div>
                </div>
                <!-- <div class="fenge"></div> -->
                <div class="listWrap">
                    <el-tabs v-model="activeName" @tab-click="handleClick" stretch >
                        <el-tab-pane label="目录" name="mulu" class="boxsh">
                            <el-collapse 
                                v-model="activeNames" 
                                @change="handleChange" 
                                class="fold" 
                                :style="{height:pinglunHeight}"
                                v-if="isChapter"
                            >
                                <el-collapse-item v-for="(item,indexParent) in courseList.chapterpartList" :title="item.name.length > 15 ? item.name = item.name.substring(0, 15)+'...': item.name" :key="indexParent" :name="indexParent" >
                                    <ul class="courseList" v-loading='companyAppLoading'>
                                        <li 
                                            class="courseItems"
                                            v-for="(item,index) in courseList.chapterpartList[indexParent].children" 
                                            :key="index"
                                            @mouseover="mouseOver(index,indexParent)" 
                                            @mouseleave="mouseLeave(index,indexParent)"
                                            :class="[mouseOverActive == item.id ? 'mouseOverClass':'',{'playCourse':activeLi==index && parentIndex==indexParent}]"
                                            @click="playChapter(item.url,index,indexParent,item.partFormat,item.id)"
                                        >
                                            <div class="flex course">
                                                <em class="iconfont icon-a-46_zhibo_sp yuyinIcon fl iconColor" v-if='item.partFormat == 1' :class="[{'fontColor':activeLi==index && parentIndex==indexParent}]"></em>
                                                <em class="iconfont icon-a-47_zhibo_yp yuyinIcon fl iconColor" v-else :class="[{'fontColor':activeLi==index && parentIndex==indexParent}]"></em>
                                                <!-- <img src="../../../assets/images/mkf.png" alt="" class="yuyinIcon fl"> -->
                                                <h3 class="courseName" :class="[{'fontColor':activeLi==index && parentIndex==indexParent}]">{{item.name}}</h3>
                                            </div>
                                            <p class="courseTime">课程时长：{{$conFun.parseMin(item.partduration)}}</p>
                                        </li>
                                    </ul>
                                </el-collapse-item>
                                
                            </el-collapse>
                            <ul class="courseList" :style="{height:pinglunHeight}" v-else>
                                <li 
                                    class="courseItems"
                                    v-for="(item,index) in courseChapter"
                                    :key="index"
                                    @mouseover="chapterOver(index)" 
                                    @mouseleave="chapterLeave(index)"
                                    :class="[mouseOverActive == item.id ? 'mouseOverClass':'',{'playCourse':activeLi==index }]"
                                    @click="play(item.url,index,item.partFormat,item.id)"
                                >
                                    <div class="flex course">
                                        <em class="iconfont icon-a-46_zhibo_sp yuyinIcon fl iconColor" v-if='item.partFormat == 1' :class="[{'fontColor':activeLi==index}]"></em>
                                        <em class="iconfont icon-a-47_zhibo_yp yuyinIcon fl iconColor" v-else :class="[{'fontColor':activeLi==index}]"></em>
                                        <!-- <img src="../../../assets/images/mkf.png" alt="" class="yuyinIcon fl"> -->
                                        <h3 class="courseName" :class="[{'fontColor':activeLi==index}]">{{item.name}}</h3>
                                    </div>
                                    <p class="courseTime">课程时长：{{$conFun.parseMin(item.partduration)}}</p>
                                </li>
                            </ul>
                        </el-tab-pane>
                        <el-tab-pane label="评论" name="pinglun">
                            <!-- <ul class="commentList">
                                <li>评论</li>
                            </ul> -->
                            <div class="discussText" :style="{height:plHeight}">
                                <ul class="discussList" ref='discussList' >
                                    <li class="discussItem" v-for='item in discussList' :key=item.id>
                                        <!-- <span v-if='item.isAssistant'>助教</span> -->
                                        <em>{{item.name}}:</em>
                                        <strong>{{item.content}}</strong>
                                    </li>
                                </ul>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="sendMsg" v-show="isShowComment">
                    <input type="text" v-model="msg" maxlength="30" placeholder="发一条积极的评论"/>
                    <button type="button" @click="addToList">发送</button>
                </div>
            </div>
            <div class="detailBox">
                <el-dialog
                    :visible.sync="dialogVisible"
                    :before-close="handleClose"
                >
                    <h3 class="className">{{courseTitle}}</h3>
                    <div class="courseContent" v-html="courseDescription"></div>
                    <!-- <img src="../../../assets/images/yinpintanchuang.png" alt="" class="audioImg"> -->
                </el-dialog>
            </div>
        </div>
        
    </div>
    
    
    
</template>

<script>
    import Cookies from "js-cookie";
    import { getCourseMessage,addWatchClassH,getFeelList,addClassComment} from '@/api/api'
    // import BreadCrumb from '../../components/BreadCrumb.vue'
    export default {
        name:'play',
        data(){
            return{
                openImg:require("../../../assets/images/shouqi.png"),
                closeImg:require("../../../assets/images/zhankai.png"),
                isHaveTip:false,
                isTesk:2,
                taskId:"",
                taskti_ID:"",
                playId:"",  //当前播放的小节的id
                courseDescription:"",
                dialogVisible: false, //详情弹窗
                plHeight:'',  //评论框高度
                activeLi:0,
                parentIndex:0,
                isVideo:false,  //第一条不是视频
                isAudioUrl:"",  //第一条音视频的地址
                isChapter:false,  //默认章为节  true为有章有节
                firstUrl:"",
                mouseOverActive:"",
                companyAppLoading:false,
                courseList:'',
                courseChapter:[], //章是节
                courseImg:'',
                courseTitle:"",
                courseTeacher:'',
                activeNames: [0],
                isShowComment:false,
                msg:"",
                coid:Cookies.get('qslCOID'),
                memberId:Cookies.get('qslmemberId'),
                myName:Cookies.get('qslmemberName'),
                courseId:"",
                page: 1,
			    pageSize: 15,
                activeName: 'mulu', //页面一加载固定在目录标签
                pinglunHeight:0,
                videoHeight:0,
                vWidth:"",
                isOpen:false,
                iconHeight:0,
                timeNumber:0,
                timer:null,
                isload:false,
                discussData:{}, //评论列表数据重新整理
                discussList:[
                    // {id:'123',name:'古拉啦huhu',content:'大家好呀~欢迎来到我们的《知识电商大咖孵化营》结 业典礼！'}
                ],
                playTime:'',
                current:'',
                playerOptions: {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: true, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        withCredentials: false,
                        type: "video/mp4", //播放类型，如果为rtmp配置为rtmp/mp4
                        src: "" //直播流地址
                    }],
                    poster: "", //你的封面地址
                    width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true, // 当前时间和持续时间的分隔符
                        durationDisplay: true, // 显示持续时间
                        remainingTimeDisplay: false, // 是否显示剩余时间功能
                        fullscreenToggle: true, //全屏按钮
                        currentTimeDisplay: true, // 当前时间
                        volumeControl: false, // 声音控制键
                        // playToggle: false, // 暂停和播放键
                    }
                },
            }
        },
        components:{},
        mounted() {
            this.iconHeight = ((this.$getViewportSize().height/2)-40)+'px';
            this.getCourseList();
            this.getCourseCommentList();
            this.$nextTick(() => {
                // 进入nexTick
                let box = this.$refs.discussList; // 在html中设置id为iii的div
                // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
                box.onscroll = () => {
                    // 获取距离顶部的距离
                    var scrollTop = box.scrollTop;
                    if (scrollTop !== 0 && this.oldv == 0) {
                    this.oldv = scrollTop;
                    }
                    // 获取可视区的高度
                    var windowHeight = box.clientHeight;
                    // 获取滚动条的总高度
                    var scrollHeight = box.scrollHeight;
                    // if (scrollTop + windowHeight >= scrollHeight) {
                    //     console.log("到达底部了");
                    // }
                    if (scrollTop == 0 && this.oldv !== 0) {
                        console.log("到达头部了");
                        if( !this.isload ){
                            this.page++;
                            this.getCourseCommentList();
                        }

                    }
                };
            });
            this.getVideoHeight();
            // 关闭页面执行
            window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
        },
        methods:{

            // openWrap(){
            //     if( !this.isOpen ){
            //         // this.vWidth = "100%";
            //         this.videoHeight = this.$getViewportSize().height;
            //         this.isOpen = true;
            //     }else{
            //         this.vWidth = "80%";
            //         this.videoHeight = this.$getViewportSize().height;
            //         this.isOpen = false;
            //     }
                
            // },

            // 鼠标移入音频/视频，顶部返回条显示/隐藏
            mouseOverBack(){
                this.isHaveTip = true;
            },
            mouseLeaveBack(){
                this.isHaveTip = false;
            },
            audioPlay(){
                console.log('开始播放音频了')
                this.timeNumber = 0
                this.timer = setInterval(this.recordTime,1000);
            },
            audioPause(){
                console.log('音频暂停播放了')
                this.funaddWatchClass(this.timeNumber);
                clearInterval(this.timer)
            },
            audioEnded(){
                console.log('音频播放结束了')
                this.funaddWatchClass(this.timeNumber);
                clearInterval(this.timer)
            },
            toDetail(){
                this.dialogVisible = !this.dialogVisible;
            },
            handleClose(done) {
                done();
            },
            backPage(){
                this.$router.go(-1);
            },
            play(url,index,yspin,id){   //有章是节的点击
                this.activeLi = index;
                this.playId = id;
                if( yspin == 1 ){
                    this.isVideo = true;
                    this.playerOptions.sources[0].src = url;
                }else{
                    this.isVideo = false;
                    this.$refs.audio_wrap.src = url;
                };
                this.funaddWatchClass(this.timeNumber);
                clearInterval(this.timer)

            },
            playChapter(url,index,pIndex,id){   //有章有节的点击
                this.playId = id;
                this.activeLi = index;
                this.parentIndex = pIndex;
                if( this.isVideo ){
                    this.playerOptions.sources[0].src = url;
                }else{
                    this.$refs.audio_wrap.src = url;
                };
                this.funaddWatchClass(this.timeNumber);
                clearInterval(this.timer)

            },
            mouseOver(index,pIndex){
                this.mouseOverActive = this.courseList.chapterpartList[pIndex].children[index].id;
            },
             // 移出
            mouseLeave() {
                this.mouseOverActive = "";
                // this.isPlayBack = false;
            },
            chapterOver(index){
                this.mouseOverActive = this.courseChapter[index].id;
            },
            chapterLeave(){
                this.mouseOverActive = "";
            },
            // 关闭窗口之前执行
            async beforeunloadHandler(e) {
                await this.funaddWatchClass(this.timeNumber);
                clearInterval(this.timer);
                // window.close()
            },
            funaddWatchClass(whTotalTime){
                var data = {
                    "whMemberid": Cookies.get('qslmemberId'),// 企业下人员ID ,
                    "whIsEnd": false,//是否结束
                    "whTaskId": this.taskId,// 任务ID 
                    "whPartid": this.playId,//: 课程小节ID ~
                    "whTaskItemId": this.taskti_ID,//子任务Id 
                    "whClassid": this.courseId,//课程ID , 
                    "whTotalTime": whTotalTime,//观看时长 ,
                    "whSource": "PC",//接口来源 Android iOS ,
                    "whType": '2',//进入类型 1 任务进入 2 直接进入 
                    "whWatchtime": "1",//观看位置
                    "whClassType": "1",//1、课程 2、语音直播 3、视频直播 4、文档 ,
                    "whCreateon":this.$conFun.getNowTime(),// '2021-12-17 22:10:22',
                    "whIsEnd": true
                }         
                addWatchClassH(data)
                .then(res => {            
                    console.log('save ok')        
                })
                .catch(err => {});
            },
            recordTime(){
                this.timeNumber++;
            },
            addToList(){
                this.msg = this.msg.trim();
                if (!this.msg) {
                    this.$alert('评论不能为空', '提示', {
                        confirmButtonText: '确定'
                    });
                    return;
                };
                let data = {
                    courseId: this.courseId,
                    parentId:'0',
                    modType:'0',
                    modId:this.courseId,
                    coid: this.coid,
                    memberId: this.memberId,
                    content: this.msg,
                };
                var that = this;
                addClassComment(data)
                    .then(res => {
                        console.log(res)
                        if( res.code == 200 ){
                            that.discussList.push({name:that.myName,content:that.msg});
                            that.scrollToBottom();
                            that.msg = '';
                        }
                    })
                    .catch(err => {
                        console.log(JSON.stringify(err));
                    });
                
            },
            //获取课程评论
            getCourseCommentList(){
                let data = {
                    modId: this.courseId,
                    coid: this.coid,
                    pageIndex: this.page,
                    pageSize: this.pageSize,
                    modType:"0",
                    parentId:"0",

                };
                var that = this;
                console.log('11')
                console.log(data)
                getFeelList(data)
                    .then(res => {
                        console.log(res)
                        if( res.code == 200 ){
                            let dmData = res.body.result.remarkList;
                            for(var i = 0; i < dmData.length ; i++ ){
                                that.discussData = {
                                    id:dmData[i].CM_ID,
                                    name:dmData[i].meName,
                                    content:dmData[i].content
                                };
                                that.discussList.unshift(that.discussData)
                            };
                            if( dmData.length != 15 ){
                                this.isload = true;
                            }
                        }
                    })
                    .catch(err => {
                        console.log(JSON.stringify(err));
                    });
            },
            scrollToBottom(){
                this.$nextTick(()=>{
                    let box = this.$refs.discussList;
                    box.scrollTop = box.scrollHeight
                })
            },
            // 获取观看课程列表
            getCourseList(){
                let data = {
                    courseId:this.courseId,
                    memberId:this.memberId,
                     modId: this.courseId,
                    watchType:2,
                    taskItemId:0
                };                
                getCourseMessage(data)
                    .then(res => {
                        if( res.code == 200 ){
                            let courseData = res.body.result;
                            this.courseList = courseData;
                            this.courseImg = courseData.cmClasscoverpic;
                            this.courseTitle = courseData.cmClassname;
                            this.courseTeacher = courseData.cmTeachername;
                            this.courseDescription = courseData.cmClassdescription;
                            this.playerOptions.poster = courseData.cmClasscoverpic;
                            if( courseData.chapterpartList.length != 0 ){   //判断是否有章
                                if( courseData.chapterpartList[0].url != "" ){  //有章是节
                                    if( courseData.chapterpartList[0].partFormat == 1 ){ //第一节是视频
                                        this.isVideo = true;
                                        this.playerOptions.sources[0].src = courseData.chapterpartList[0].url;
                                    }else{  //第一节是音频
                                        this.isVideo = false;
                                        this.$refs.audio_wrap.src = courseData.chapterpartList[0].url;
                                        
                                    };
                                    this.playId = courseData.chapterpartList[0].id;
                                    this.courseChapter = this.courseChapter.concat(courseData.chapterpartList);

                                }else{
                                    this.isChapter = true;  //有章有节
                                    if( courseData.chapterpartList[0].children[0].partFormat == 1 ){ //第一节是视频
                                        this.isVideo = true;
                                       
                                        this.playerOptions.sources[0].src = courseData.chapterpartList[0].children[0].url;
                                    }else{  //第一节是音频
                                        this.isVideo = false;
                                        this.$refs.audio_wrap.src = courseData.chapterpartList[0].children[0].url;
                                        
                                    };
                                    this.playId = courseData.chapterpartList[0].id;
                                };
                            }
                            
                            
                        }
                    }).catch(err => {
                        
                    });
            },
            handleChange(val) {
                console.log(val)
            },
            handleClick(tab, event) {
                let eventName = event.target.innerText
                if( eventName == "评论" ){
                    this.isShowComment = true;
                }else{
                    this.isShowComment = false;
                };
            },
            // 获取视频的高度给评论区
            getVideoHeight(){
                this.videoHeight = this.$getViewportSize().height+'px';
                this.pinglunHeight = (this.$getViewportSize().height-(162+24+64))+'px';
                this.plHeight = (this.$getViewportSize().height-(162+24+64+72))+'px';
                
            },
            // 播放回调
            onPlayerPlay(player) {
                console.log("播放啦啦啦！", player);
                this.timeNumber = 0
                this.timer = setInterval(this.recordTime,1000);
            },
            // 暂停回调
            onPlayerPause(player) {
                console.log("已经暂停喽！", player);
                this.funaddWatchClass(this.timeNumber);
                clearInterval(this.timer)
            },
             // 视频播完回调
            onPlayerEnded($event) {
                console.log("播放完喽！",$event);
                this.funaddWatchClass(this.timeNumber);
                clearInterval(this.timer)
            },
            // 当前播放位置发生变化时触发。
            onPlayerTimeupdate($event) {
                // console.log($event.cache_.currentTime)
            },
            //播放状态改变回调
            playerStateChanged(playerCurrentState) {
                
                // console.log('播放器当前更新状态', playerCurrentState)
            },
            //将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
            playerReadied(player) {
                console.log('播放器已就位', player);
                // player.currentTime(this.current)
            },
        },
        created(){
            this.courseId = this.$route.query.courseId;
            this.taskId = this.$route.query.taskId;
            this.taskti_ID = this.$route.query.taskTI_ID;
            if( this.taskId == undefined ){
                this.taskId = 0;
            }
            if( this.taskti_ID == undefined ){
                this.taskti_ID = 0;
            }
            // window.addEventListener('resize',this.getVideoHeight);
            
        },
        updated(){
            this.scrollToBottom();
        },
        beforeDestroy(){
            
        },
        destroyed(){
            this.funaddWatchClass(this.timeNumber);
            clearInterval(this.timer);
        },
    }
</script>
<style scoped>
    .courseHeader{
        width: 100%;
        height: 162px;
        background: #fff;
        padding: 25px;
    }
    .courseHeader img{
        width: 127px;
        height: 75px;
    }
    .courseTitle{
        color: #999;
        font-size: 24px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-left: 9px;
    }
    .wrap{
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .backTip{
        position:absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 65px;
        line-height: 65px;
        background: rgba(153, 153, 153, 0.4);
        /* background: rgba(0, 0, 0, 0.4); */
        z-index: 100;
        
    }
    .backTip img{
        float: left;
        width: 9px;
        margin-left: 24px;
        cursor: pointer;
        margin-top: 25px;
    }
    .backTip span{
        color: #F0F0F0;
        font-size: 18px;
        margin-left: 16px;
        cursor: pointer;
    }
    .backTip i{
        color: #fff;
        font-size: 24px;
        margin-top: 20px;
        cursor: pointer;
        margin-right: 10px;
    }
    .clearn:after{
        content:".";       
        display:block;       
        height:0;       
        clear:both;       
        visibility:hidden;       
    }
    .videoWrap{
        width: 100%;
        position: relative;
    }
    .videoBox{
        /* float: left; */
        width: 80%;
        object-fit:fill;
        overflow: hidden;
    }
    
    .ypImg{
        display:table-cell;
        vertical-align: middle;
        
        /* height: 100%; */
    }
    .ypImg img{
        width: 100%;
    }
    .ypCourse{
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 10px;
    }
    .commentWrap{
        background: #f3f4f7;
        width: 20%;
        position: relative;
        overflow: hidden;
    }
    .courseTeacher{
        margin-top: 20px;
    }
    .courseTeacher span{
        color: #666;
    }
    .courseTeacher em{
        font-style: normal;
    }
    .courseDetail{
        color: #4B9AFB;
        cursor: pointer;
    }
    .listWrap{
        height: 64px;
        background: #fff;
        margin-top: 24px;
        
        /* box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15); */
    }
    /* .fenge{
        height: 24px;
        background: #f3f4f7;
    } */
    >>>.el-tabs__active-bar{
        background: none;
    }
    >>>.el-tabs__nav.is-stretch{
        background: none;
    }
    >>>.el-tabs__header{
        margin: 0;
    }
    >>>.el-tabs__item{
        height: 64px;
        line-height: 64px;
        font-size: 18px;
        padding: 0;
        text-align: left;
    }
    >>>.el-tabs__nav.is-stretch{
        min-width: 50%;
    }
    >>>.el-tabs__nav-scroll{
        margin-left: 43px;
    }
    .courseItems{
        width: 100%;
        height: 100px;
        background: #fff;
        border-left: 8px solid #fff;
        cursor: pointer;
    
    }
    .playCourse{
        border-left: 8px solid #4B9AFB;
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15); 
        position: relative;
    }
    .mouseStyle{
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15);
    }
    .courseList{
       height: 100%;
       background: #fff;
       /* overflow: auto; */
        overflow-x: hidden;
        overflow-y: auto;
    }
    /*滚动条样式*/
        .courseList::-webkit-scrollbar {
            width: 8px;    
            /*height: 4px;*/
        }
        .courseList::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
        }
        .courseList::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);

        }
    >>>.el-tabs__nav-wrap::after{
        background: none;
    }
    >>>.el-tabs__nav-wrap{
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15);
        z-index: 1000;
    }
    .course{
        padding: 0 20px;
        padding-top: 20px;
    }
    .iconColor{
        display: inline-block;
        font-size: 20px;
        color: #ccc;
    }
    .yuyinIcon{
        vertical-align: top;
        margin-right: 10px;
    }
    .courseName{
        font-weight: normal;
        color: #333;
        font-size: 16px;
        margin-bottom: 0;
        line-height: 21px;
        margin-top: 0;
    }
    .courseTime{
        margin: 0;
        padding-left: 48px;
        margin-top: 10px;
        font-size: 14px;
        color: #999;
    }
    .commentList{
        height: 100%;
        background: pink;
    }
    .sendMsg{
        width: 100%;
        height: 72px;
        position: absolute;
        right: 0;
        bottom: 0;
        background: #ffffff;
        box-shadow: 0px -1px 10px 0px rgba(0,0,0,0.10); 
        padding: 0 24px;
    }
    .sendMsg input{
        float: left;
        width: 70%;
        height: 40px;
        background: #f0f0f0;
        border-radius: 4px;
        margin-top: 16px;
        border: none;
        margin-right: 5%;
        padding-left:15px ;
        font-size: 14px;
        color: #333;
        outline: none;
    }
    .sendMsg button{
        float: left;
        width: 25%;
        height: 40px;
        background: #4B9AFB;
        border-radius: 8px;
        border: none;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        margin-top: 16px;
    }
    .fold{
        overflow: auto;
    }
    >>>.el-collapse-item__header{
        height: 64px;
        line-height: 64px;
        padding-left: 25px;
        position: relative;
        font-size: 18px;
        color: #333;
        /* width: 100%; */
        white-space:nowrap; 
        overflow:hidden; 
        text-overflow:ellipsis;
    }
    .activeItem{
        border: 1px solid #dddddd;
        box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.15); 
    }
    .mouseOverClass{
        background:#e4f0fe;
        border-left: 8px solid #e4f0fe;
    }
    .fontColor{
        color: #4B9AFB;
    }
    .discussText{
        /* height: 100%; */
        background: #fff;
    }
    .discussList{
        height: 100%;
        margin: 0;
        padding: 24px;
        overflow: auto;
    }
    .discussItem{
        margin-bottom: 6px;
    }
    .discussItem span{
        display: inline-block;
        width: 40px;
        height: 20px;
        background: #4B9AFB;
        border-radius: 2px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
    }
    .discussItem em{
        font-style: normal;
        color:#999999;
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        font-weight: Normal;
        text-align: left;
        color: #999999;
        line-height: 18px;
        letter-spacing: 1px;
    }
    .discussItem strong{
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN-Normal;
        font-weight: Normal;
        text-align: left;
        color: #333333;
        line-height: 22px;
    }
    
    .audioImg{
        width: 100%;
    }
    >>>.el-dialog__header{
        padding: 0;
    }
    >>> .el-dialog__body{
        padding: 0;
        border-radius: 5px;
    }
    >>>.el-dialog{
        background: none;
        -weblit-box-shadow:none;
        box-shadow:none;
        width: 760px;
        overflow: hidden;
        border-radius: 5px;
    }
    >>>.el-icon-close{
        position: relative;
        z-index: 1000;
    }
    .className{
        background: #fff;
        color: #333;
        font-size: 18px;
        width: 100%;
        height: 64px;
        line-height: 64px;
        /* font-weight: normal; */
        position: absolute;
        left: 0;
        top: 0;
        padding-left: 24px;
        margin: 0;
    }
    >>>.el-dialog__body p{
        margin: 0;
        font-size: 18px;
        color: #666666;
    }
    >>>.vjs-custom-skin > .video-js{
        height: 100%;
    }
    .courseContent p img{
        width: 760px;
    }
    .courseContent{
        width: 760px;
        height: 470px;
        overflow: auto;
        line-height: 27px;
        background: #fff;
        padding: 24px;
        padding-top: 64px;
    }
    .putAway{
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/home/Course/play.vue